var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-ons-page',[_c('v-ons-navigator',{attrs:{"id":"navigator","var":"navigator","swipeable":"","options":_vm.navigatorOptions,"page-stack":_vm.pageStack},on:{"push-page":_vm.push,"pop-page":function($event){_vm.$emit('pop-page')},"toggleMainMenu":function($event){_vm.$emit('toggleMainMenu')},"refreshContent":_vm.rfct}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20d54b1a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Navigator.vue
// module id = null
// module chunks = 